import { useTranslation } from 'react-i18next'

import { ClockIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Button, Modal, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const LinkExpiredModal = ({ show, onRequestNewLink, onBack }) => {
  const { t } = useTranslation()
  const theme = useTheme()

  return (
    <Modal
      show={show}
      onClose={onBack}
      size="m"
      actions={
        <Styles.Actions>
          <Button fullWidth onClick={onRequestNewLink}>
            {t('Solicitar un enlace nuevo')}
          </Button>
          <Button fullWidth variant="text" onClick={onBack}>
            {t('Volver')}
          </Button>
        </Styles.Actions>
      }
    >
      <Styles.Content>
        <ClockIcon size={40} color={theme.title.primary} />
        <Text type="titleM">{t('Este enlace ya no es válido')}</Text>
        <Text type="bodyMRegular">
          {t(
            'Por seguridad, este enlace solo se puede usar una vez y caduca a las 2 horas. Solicita uno nuevo para acceder a tus pedidos.'
          )}
        </Text>
      </Styles.Content>
    </Modal>
  )
}

export default LinkExpiredModal
